import React, { createContext } from 'react';

export const ChatMessageListScrollContext =
  createContext<React.RefObject<HTMLDivElement | null> | null>(null);
